import { Audience } from '@/features/payin/payinSlice';
import { paymentsApi } from '.';

export interface PayinRequest {
  id: string,
  transactionId: string,
  created: number,
  updated: number,
  address1: string,
  address2: string,
  address3: string,
  town: string,
  country: string,
  postcode: string,
  Event: null,
  audience?: Audience,
  WhatYouDid: string,
  permission: null,
  permissionEmail: number | null,
  permissionPhone: number | null,
  permissionPost: number | null,
  permissionSMS: number | null,
  phone: null,
  mobile: null,
  establishmentId: string,
  jobTitle: string,
  schoolType: string,
  establishment_name: string,
  organisation: string,
  organisationFreetext: null,
  fundraising_activity: string,
  ukActiveMember: null,
  certificate: null,
}

export interface PayinResponse {
  data: object,
  message: string,
}

const extendedPaymentsApi = paymentsApi.injectEndpoints({
  endpoints: builder => ({
    payin: builder.mutation<PayinResponse, PayinRequest>({
      query: body => ({
        url: 'payin',
        method: 'POST',
        body,
      })
    })
  })
});

export const { usePayinMutation } = extendedPaymentsApi;
